import { formatAmount } from 'utils/format';

// @NOTE-AC: Copied from
// https://github.com/joindeed/marketplace/blob/b5f5490cc4ee6280299e6c02a92910d4425bca91/packages/mongoose-models/src/utils/currency.ts
// To check for inconsistencies
// TODO: Make this a package

export enum UserCurrencies {
  // BaseCurrencies
  EUR = 'EUR',
  USD = 'USD',
  CAD = 'CAD',
  GBP = 'GBP',
  AUD = 'AUD',
  RON = 'RON',
  SGD = 'SGD',
  INR = 'INR',
  HKD = 'HKD',
  NZD = 'NZD',
  BRL = 'BRL',
  MXN = 'MXN',
  JPY = 'JPY',
  DKK = 'DKK',
  PLN = 'PLN',
  NOK = 'NOK',
  SEK = 'SEK',
  HUF = 'HUF',
  CZK = 'CZK',
  CHF = 'CHF',
  // Non BaseCurrencies
  ILS = 'ILS',
  ZAR = 'ZAR',
  TRY = 'TRY',
  ARS = 'ARS',
  CLP = 'CLP',
  PEN = 'PEN',
  COP = 'COP',
  BOB = 'BOB',
  CNY = 'CNY',
  KRW = 'KRW',
  PHP = 'PHP',
  THB = 'THB',
  KZT = 'KZT',
  UAH = 'UAH',
  CRC = 'CRC',
  IDR = 'IDR',
  VND = 'VND',
  // EGP = 'EGP',
  // JOD = 'JOD',
  // MAD = 'MAD',
}

export const currencies: Currencies = {
  USD: {
    symbol: '$',
    code: 'USD',
    label: '$ US dollar (USD)',
    rates: null,
  },
  EUR: {
    symbol: '€',
    code: 'EUR',
    label: '€ Euro (EUR)',
    rates: null,
  },
  GBP: {
    symbol: '£',
    code: 'GBP',
    label: '£ Pound sterling (GBP)',
    rates: null,
  },
  CHF: {
    symbol: 'CHF',
    code: 'CHF',
    label: 'Swiss franc (CHF)',
    rates: null,
  },
  CAD: {
    symbol: 'CA$',
    code: 'CAD',
    label: '$ Canadian dollar (CAD)',
    rates: null,
  },
  AUD: {
    symbol: 'AU$',
    code: 'AUD',
    label: '$ Australian dollar (AUD)',
    rates: null,
  },
  RON: {
    symbol: 'lei',
    code: 'RON',
    label: 'L Romanian Leu (RON)',
    rates: null,
  },
  SGD: {
    symbol: 'S$',
    code: 'SGD',
    label: '$ Singapore dollar (SGD)',
    rates: null,
  },
  INR: {
    symbol: '₹',
    code: 'INR',
    label: '₹ Indian rupee (INR)',
    rates: null,
  },
  HKD: {
    symbol: 'HK$',
    code: 'HKD',
    label: '$ Hong Kong dollar (HKD)',
    rates: null,
  },
  NZD: {
    symbol: 'NZ$',
    code: 'NZD',
    label: '$ New Zealand dollar (NZD)',
    rates: null,
  },
  JPY: {
    symbol: '¥',
    code: 'JPY',
    label: '¥ Yen (JPY)',
    rates: null,
  },
  DKK: {
    symbol: 'kr.',
    code: 'DKK',
    label: 'Danish krone (DKK)',
    rates: null,
  },
  ILS: {
    symbol: '₪',
    code: 'ILS',
    label: '₪ Israeli shekel (ILS)',
    rates: null,
  },
  ZAR: {
    symbol: 'R',
    code: 'ZAR',
    label: 'South African rand (ZAR)',
    rates: null,
  },
  TRY: {
    symbol: '₺',
    code: 'TRY',
    label: '₺ Turkish lira (TRY)',
    rates: null,
  },
  ARS: {
    symbol: 'ARS$',
    code: 'ARS',
    label: '$ Argentine peso (ARS)',
    rates: null,
  },
  BRL: {
    symbol: 'R$',
    code: 'BRL',
    label: '$ Brazilian real (BRL)',
    rates: null,
  },
  MXN: {
    symbol: 'Mex$',
    code: 'MXN',
    label: '$ Mexican peso (MXN)',
    rates: null,
  },
  CLP: {
    symbol: 'CLP$',
    code: 'CLP',
    label: '$ Chilean peso (CLP)',
    rates: null,
  },
  PEN: {
    symbol: 'S/',
    code: 'PEN',
    label: 'S/ Peruvian sol (PEN)',
    rates: null,
  },
  COP: {
    symbol: 'COL$',
    code: 'COP',
    label: '$ Colombian peso (COP)',
    rates: null,
  },
  PLN: {
    symbol: 'zł',
    code: 'PLN',
    label: 'zł Polish złoty (PLN)',
    rates: null,
  },
  BOB: {
    symbol: 'Bs',
    code: 'BOB',
    label: 'Bs Bolivian boliviano (BOB)',
    rates: null,
  },
  CNY: {
    symbol: 'CN¥',
    code: 'CNY',
    label: 'CN¥ Chinese yuan renminbi (CNY)',
    rates: null,
  },
  KRW: {
    symbol: '₩',
    code: 'KRW',
    label: '₩ South Korean won (KRW)',
    rates: null,
  },
  PHP: {
    symbol: '₱',
    code: 'PHP',
    label: '₱ Philippine peso (PHP)',
    rates: null,
  },
  THB: {
    symbol: '฿',
    code: 'THB',
    label: '฿ Thai baht (THB)',
    rates: null,
  },
  KZT: {
    symbol: '₸',
    code: 'KZT',
    label: '₸ Kazakhstani tenge (KZT)',
    rates: null,
  },
  UAH: {
    symbol: '₴',
    code: 'UAH',
    label: '₴ Ukrainian hryvnia (UAH)',
    rates: null,
  },
  CZK: {
    symbol: 'Kč',
    code: 'CZK',
    label: 'Kč Czech Koruna (CZK)',
    rates: null,
  },
  HUF: {
    symbol: 'Ft',
    code: 'HUF',
    label: 'Ft Hungarian forint (HUF)',
    rates: null,
  },
  SEK: {
    symbol: 'kr',
    code: 'SEK',
    label: 'kr Swedish Krona (SEK)',
    rates: null,
  },
  NOK: {
    symbol: 'kr',
    code: 'NOK',
    label: 'kr Norwegian Krone (NOK)',
    rates: null,
  },
  CRC: {
    symbol: '₡',
    code: 'CRC',
    label: 'Costa Rican colón (CRC)',
    rates: null,
  },
  IDR: {
    symbol: 'Rp',
    code: 'IDR',
    label: 'Indonesian Rupian (IDR)',
    rates: null,
  },
  VND: {
    symbol: '₫',
    code: 'VND',
    label: 'Vietnamese dong (VND)',
    rates: null,
  },
  // EGP: {
  //   symbol: 'E£',
  //   code: 'EGP',
  //   label: 'E£ Egyptian pound (EGP)',
  //   rates: null,
  // },
  // JOD: {
  //   symbol: 'JOD',
  //   code: 'JOD',
  //   label: 'Jordanian dinar (JOD)',
  //   rates: null,
  // },
  // MAD: {
  //   symbol: 'DH',
  //   code: 'MAD',
  //   label: 'DH Moroccan dirham (MAD)',
  //   rates: null,
  // },
};

export type CurrencyCode =
  | 'USD'
  | 'EUR'
  | 'CHF'
  | 'GBP'
  | 'CAD'
  | 'AUD'
  | 'RON'
  | 'SGD'
  | 'INR'
  | 'HKD'
  | 'NZD'
  | 'JPY'
  | 'DKK'
  | 'ILS'
  | 'ZAR'
  | 'TRY'
  | 'ARS'
  | 'BRL'
  | 'MXN'
  | 'CLP'
  | 'PEN'
  | 'COP'
  | 'PLN'
  | 'BOB'
  | 'CNY'
  | 'KRW'
  | 'PHP'
  | 'THB'
  | 'KZT'
  | 'UAH'
  | 'CZK'
  | 'HUF'
  | 'SEK'
  | 'NOK'
  | 'CRC'
  | 'VND'
  | 'IDR';

// | 'EGP'
// | 'JOD'
// | 'MAD'

export type AmountCurrencies = Record<CurrencyCode, number>;

export interface Currency {
  symbol: string;
  code: CurrencyCode;
  label: string;
  rates: AmountCurrencies | null;
}

type Currencies = {
  [currencyCode in UserCurrencies]: Currency;
};

export const isNegative = (amount: number) => Math.sign(amount) === -1;

export const currencyFormat = (
  amount: number,
  currencyCode: CurrencyCode,
  short = false
): string => {
  const currencySymbol = currencies[currencyCode]?.symbol || '';
  return `${isNegative(amount) ? '-' : ''}${currencySymbol}${formatAmount(
    Math.abs(amount || 0),
    short
  )}`;
};

export const currenciesFormat = (
  amountCurrencies: AmountCurrencies,
  currencyCode: CurrencyCode
): string => {
  const amount = amountCurrencies?.[currencyCode] || 0;
  return currencyFormat(amount, currencyCode);
};
